<div id="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-lg-3">
                <div class="widget dark">
                    <div class="footer-logo">
                        <img class="mt-3 mb-2 img-fluid rounded" alt="Logo" src="/assets/img/logo/2.png">
                    </div>
                  
                  <h4 class=" text-center mb-0">MAHARANA PRATAP PUBLIC SCHOOL</h4>
                  <p class="text-center">Kurukshetra,(Haryana) 136118</p>
                  <ul class="list-inline  text-center">
                    <li class="m-0 ps-10 pr-10"> <i class="fa fa-phone me-2"></i> <a  href="tel:8059700244">8059700244</a> </li>
                    <li class="m-0 ps-10 pr-10"> <i class="fa fa-envelope-o  me-2"></i> <a class="spamspan" href="mailto:maharanapratapschool@yahoo.co.in">maharanapratapschool@yahoo.co.in</a> </li>
                    <li class="m-0 ps-10 pr-10"> <i class="fa fa-globe  me-2"></i> <a  href="javascript:void(0)">mppskkr.com</a> </li>
                  </ul>
                  <ul class="social clearfix mt-10 text-center">
                    <li><a href="#" target="_blank" aria-label="Twitter"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="#" target="_blank" aria-label="Linkedin"><i class="fa fa-linkedin text-white"></i></a></li>
                    <li><a href="https://www.facebook.com/profile.php?id=100063570684714" target="_blank" aria-label="Facebook"><i class="fa fa-facebook"></i></a></li> 
                    <li><a href="#" target="_blank" aria-label="Youtube"><i class="fa fa-youtube-play"></i></a></li>
                            
                  </ul>
                </div>
              </div>
            <div class="col-md-6 col-lg-3">
                <div class="link">
                    <h4 >Quick Link</h4>
                    <hr class="opacity-100">
                    <ul class="ps-0">
                        <li><a routerLink="/campus/labs" >Laboratories</a></li>
                        <!-- <li><a routerLink="/not-found">Centres</a></li> -->
                        <li><a routerLink="/campus/transport" >Transport</a></li>
                        <li><a routerLink="/campus/infrastructure" >Infrastructure Type</a></li>
                        <li><a routerLink="/faculty/list" >Faculty List</a></li>
                        <!-- <li><a routerLink="/not-found">Right to Information</a></li> -->
                        <li><a routerLink="/achievements/awards" >Awards and Scholarships</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="link borderRight">
                    <h4 >Explore</h4>
                    <hr class="opacity-100">
                    <ul class="ps-0">
                        <li><a routerLink="/achievements/cbse">CBSE Result</a></li>
                        <!-- <li><a routerLink="/not-found">Institute Newsletter</a></li> -->
                        <li><a routerLink="/admission/library"> Library and eBooks</a></li>
                        <li><a routerLink="/admission/hours">School Hours</a></li>
                        <li><a routerLink="/admission/process">Admission Process</a></li>
                        <li><a routerLink="/contact-us">Contact Us</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-lg-3">
               <app-map></app-map>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-left">
                <a class="design" target="_blank">No. of Visitors: {{count}}</a>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12 text-right">
                <a href="https://okiedokiepay.com/" class="design" target="_blank">Copyright © 2022. Designed By: Okie Dokie Solutions LLP</a>
            </div>
        </div>
    </div>
</div>